import { FaRegUserCircle } from "react-icons/fa";
import { Button } from "../../components/forms/Form";
import "./SideMenu.css";

function Userinfo({ firstname, lastname, email }) {
  return (
    <div className="settings-user-info">
      <div className="settings-user-info-icon">
        <FaRegUserCircle style={{ fontSize: "20px" }} />
      </div>
      <div>
        <p className="settings-user-info-username">
          {firstname} {lastname}
        </p>
        <p className="settings-user-info-email">{email}</p>
      </div>
    </div>
  );
}

export default function SideMenu(props) {
  return (
    <div className="settings-side-menu">
      <div className="settings-side-menu-container">
        <div>
          <Userinfo
            firstname={props.userData ? props.userData.firstname : ""}
            lastname={props.userData ? props.userData.lastname : ""}
            email={props.userData ? props.userData.email : ""}
          />
          <ul className="settings-option-container">
            <li className="settings-option">Impostazioni account</li>
          </ul>
        </div>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <a href="mailto:hello@farmakom.it">Contatta Farmakom</a>
          <div className="settings-side-menu-button">
            <Button text={"ESCI"} handleSubmit={props.logout} />
          </div>
        </div>
      </div>
    </div>
  );
}
